module.exports = __webpack_public_path__ + "img/arrow.e4d76620.svg";